import { KeycloakToken } from "@youm-front/keycloak/domain";
import { Observable } from "rxjs";

export abstract class KeycloakService {
  abstract init$: Observable<null | KeycloakToken>;

  abstract get onSuccessRedirectToRedirectUri$(): Observable<void>;
  abstract get token(): undefined | KeycloakToken;

  abstract signOut(): Promise<void>;
  abstract login(): Promise<void>;
}
